jQuery(function($){
  var $buttons    = $('.date-picker button');
  var $firstBtn   = $buttons.first();
  var lastSignature = null;
  var saveTimer = null;
  var isComposing = false;

  var closedDates = [
    'Feb 16, 2026'
  ];

  function formatFullDate(d) {
    var monthShort = d.toLocaleString('en-US', { month: 'short' });
    var day = d.getDate();
    var year = d.getFullYear();
    return monthShort + ' ' + day + ', ' + year;
  }

  function updateCartAttributes(date) {
    var cardMsg = $('#CartDrawer-Note').val() || '';
    var payload = {
      attributes: {
        'Card Message': cardMsg,
        'Selected Date': date || '',
        'Type': 'Web Order'
      }
    };

    var signature = JSON.stringify(payload.attributes);
    if (signature === lastSignature) return;
    lastSignature = signature;

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(payload)
    }).catch(function(){});
  }

  function updateDeliveryDisplay(date) {
    $('cart-delivery-date span, #cart-delivery-date span').text(date || '');
  }

  function highlightCalendarDate(date) {
    if (!date) return;
    var d = new Date(date);
    if (isNaN(d.getTime())) return;

    var day = d.getDate();
    var monthLong = d.toLocaleString('en-US', { month: 'long' });
    var year = d.getFullYear();

    $('.calendar-month').each(function() {
      var $m = $(this);
      var header = $m.find('h3').text().trim();
      if (header.includes(monthLong) && header.includes(String(year))) {
        $m.find('.day').removeClass('active-date');
        $m.find('.day').each(function() {
          if (parseInt($(this).text(), 10) === day) $(this).addClass('active-date');
        });
      }
    });
  }

  function activatePickerButton(date) {
    if (!date) return;
    $buttons.removeClass('active');
    $buttons.filter('[data-full-date="' + date + '"]').addClass('active');
  }

  function setSelectedDate(date) {
    if (!date) return;
    localStorage.setItem('selectedDate', date);
    window.selectedDate = date;
    activatePickerButton(date);
    updateDeliveryDisplay(date);
    highlightCalendarDate(date);
    updateCartAttributes(date);
  }

  function markClosedSundaysInCalendar() {
    $('.calendar-month').each(function() {
      var $m = $(this);
      var header = $m.find('h3').text().trim();
      if (!header) return;

      $m.find('.day').each(function() {
        var $day = $(this);
        var dayNum = parseInt($day.text(), 10);
        if (!dayNum) return;

        var tmp = new Date(header + ' ' + dayNum);
        if (isNaN(tmp.getTime())) return;

        var formatted = formatFullDate(tmp);

        if (tmp.getDay() === 0 || closedDates.indexOf(formatted) !== -1) {
          $day.addClass('closed').attr('aria-disabled', 'true');
        }
      });
    });
  }

  function computeInitialDate() {
    var saved = localStorage.getItem('selectedDate');
    var today = new Date();
    var todayMidnight = new Date(today.getFullYear(), today.getMonth(), today.getDate());

    if (saved) {
      var savedDate = new Date(saved);

      if (!isNaN(savedDate.getTime())) {
        var savedMidnight = new Date(
          savedDate.getFullYear(),
          savedDate.getMonth(),
          savedDate.getDate()
        );

        if (savedMidnight <= todayMidnight) {
          var tomorrow = new Date(
            todayMidnight.getFullYear(),
            todayMidnight.getMonth(),
            todayMidnight.getDate() + 1
          );
          var target = tomorrow;

          if (tomorrow.getDay() === 0) {
            target = new Date(
              tomorrow.getFullYear(),
              tomorrow.getMonth(),
              tomorrow.getDate() + 1
            );
          }

          var targetStr = formatFullDate(target);

          if (!$buttons.filter('[data-full-date="' + targetStr + '"]').length) {
            var $fallback = $buttons.not('.closed').filter(':not(:disabled)').first();
            if ($fallback.length) {
              targetStr = $fallback.data('full-date');
            } else if ($firstBtn.length) {
              targetStr = $firstBtn.data('full-date');
            } else {
              targetStr = null;
            }
          }

          return targetStr;
        }

        return saved;
      }
    }

    var tomorrow = new Date(
      todayMidnight.getFullYear(),
      todayMidnight.getMonth(),
      todayMidnight.getDate() + 1
    );
    var target = tomorrow;

    if (tomorrow.getDay() === 0) {
      target = new Date(
        tomorrow.getFullYear(),
        tomorrow.getMonth(),
        tomorrow.getDate() + 1
      );
    }

    var targetStr = formatFullDate(target);

    if (!$buttons.filter('[data-full-date="' + targetStr + '"]').length) {
      var $fallback = $buttons.not('.closed').filter(':not(:disabled)').first();
      if ($fallback.length) {
        targetStr = $fallback.data('full-date');
      } else if ($firstBtn.length) {
        targetStr = $firstBtn.data('full-date');
      } else {
        targetStr = null;
      }
    }

    return targetStr;
  }

  markClosedSundaysInCalendar();

  var initialDate = computeInitialDate();
  if (initialDate) {
    setSelectedDate(initialDate);
  }

  $('.date-picker').on('click', 'button', function() {
    if (this.disabled || $(this).hasClass('closed')) return;
    setSelectedDate($(this).data('full-date'));
  });

  $('.calendar-modal').on('click', '.calendar-month .day', function() {
    var $day = $(this);

    if ($day.hasClass('disabled') || $day.hasClass('closed')) return;

    var dayNum = parseInt($day.text(), 10);
    var heading = $day.closest('.calendar-month').find('h3').text().trim();
    var tmp = new Date(heading + ' ' + dayNum);
    if (isNaN(tmp.getTime())) return;

    var fullDateStr = formatFullDate(tmp);
    setSelectedDate(fullDateStr);

    $('.calendar-modal').fadeOut();
  });

  // ---- Mobile IME / autocorrect support ----
  $(document).on('compositionstart', '#CartDrawer-Note', function() {
    isComposing = true;
  });

  $(document).on('compositionend', '#CartDrawer-Note', function() {
    isComposing = false;
    clearTimeout(saveTimer);
    saveTimer = setTimeout(function () {
      updateCartAttributes(window.selectedDate);
    }, 0);
  });

  $(document).on('input', '#CartDrawer-Note', function() {
    if (isComposing) return;
    clearTimeout(saveTimer);
    saveTimer = setTimeout(function () {
      updateCartAttributes(window.selectedDate);
    }, 250);
  });

  $(document).on('click', 'button[name="checkout"], input[name="checkout"], a[href^="/checkout"]', function (e) {
    clearTimeout(saveTimer);

    var noteEl = document.getElementById('CartDrawer-Note');

    // Force commit of last mobile keystrokes/autocorrect
    if (noteEl && document.activeElement === noteEl) noteEl.blur();

    e.preventDefault();

    setTimeout(function () {
      var cardMsg = noteEl ? noteEl.value : ($('#CartDrawer-Note').val() || '');

      var attrs = {
        'Card Message': cardMsg,
        'Selected Date': window.selectedDate || '',
        'Type': 'Web Order'
      };

      var signature = JSON.stringify(attrs);
      if (signature === lastSignature) {
        window.location.href = '/checkout';
        return;
      }

      lastSignature = signature;

      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ attributes: attrs })
      }).finally(function () {
        window.location.href = '/checkout';
      });
    }, 0);
  });
});
